import { render } from "./AdminResetPass.vue?vue&type=template&id=9a3b4e62&scoped=true"
import script from "./AdminResetPass.vue?vue&type=script&lang=js"
export * from "./AdminResetPass.vue?vue&type=script&lang=js"

import "./AdminResetPass.vue?vue&type=style&index=0&id=9a3b4e62&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a3b4e62"]])

export default __exports__